import React from 'react';
import mangalsutra from '../../assests/collectionImg/mangalsutra.jpg';
import hath_pan from '../../assests/collectionImg/hath pan.jpg';
import maag_tikka from '../../assests/collectionImg/maag tikka.jpeg';
import ring from '../../assests/collectionImg/ring.webp';

interface DealCardProps {
  title: string;
  imgSrc: string;
  discount: string;
  category: string;
  link: string; // 🛑 Added link property
}

// createSlug ab zaruri nahi hai kyunki links seedhe data mein hain

const DealCard: React.FC<DealCardProps> = ({ title, imgSrc, discount, category, link }) => {
  return (
    <div className="bg-[#C4A484] shadow-md hover:shadow-2xl transition-all duration-300 p-6 flex flex-col items-center text-center transform hover:scale-105 border border-purple-100 hover:border-yellow-400 min-h-[460px]">
      <img
        src={imgSrc}
        alt={title}
        className="w-full h-52 object-cover mb-4 hover:opacity-90 transition"
      />
      <div className="w-12 h-1 bg-yellow-400 mb-4"></div>
      <h3 className="text-2xl font-bold text-gray-800">{title}</h3>
      <p className="text-sm text-gray-600 mt-1">{category}</p>
      <p className="text-lg font-bold text-purple-700 mt-2">{discount}</p>
      
      {/* 🛑 Using the explicit 'link' property from props */}
      <a 
        href={link} 
        className="mt-4 bg-purple-700 hover:bg-purple-800 text-white font-semibold py-2 px-6 rounded-full transition duration-300 inline-block" 
      >
        Shop Now
      </a>
      
    </div>
  );
};

const DealPage: React.FC = () => {
  const deals = [
    {
      title: 'Mangalsutra',
      imgSrc: mangalsutra,
      discount: '20% OFF',
      category: 'Jewellery',
      link: '/mangalsutra', // 🛑 Specific Link 1
    },
    {
      title: 'Hath Pan',
      imgSrc: hath_pan,
      discount: '25% OFF',
      category: 'Jewellery',
      link: '/hathpan', // 🛑 Specific Link 2
    },
    {
      title: 'Maang Tikka',
      imgSrc: maag_tikka,
      discount: '30% OFF',
      category: 'Jewellery',
      link: '/maangtikka', // 🛑 Specific Link 3
    },
    {
      title: 'Ring',
      imgSrc: ring,
      discount: '15% OFF',
      category: 'Jewellery',
      link: '/rings', // 🛑 Specific Link 4
    },
  ];

  return (
    <div className="max-w-screen-xl mx-auto py-12 px-4 text-center">
      <h2 className="text-3xl font-semibold mb-8 font-[Cinzel] bg-gradient-to-r from-yellow-600 via-yellow-500 to-yellow-400 bg-clip-text text-transparent">
        Deals of the Day
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {deals.map((deal, index) => (
          <DealCard
            key={index}
            title={deal.title}
            imgSrc={deal.imgSrc}
            discount={deal.discount}
            category={deal.category}
            link={deal.link} // 🛑 Passing the new link property
          />
        ))}
      </div>
    </div>
  );
};

export default DealPage;